import axios from 'axios';

import { PlanGroup, PlanUnit } from 'components/types';

import { PLAN_GROUPS } from 'RestAPIs/endpoints';

export const getPlanGroups = () => axios.get<PlanGroup[]>(PLAN_GROUPS);

type SaveBody = {
  name: string;
  costCenters: PlanUnit[];
};

export const savePlanGroup = (body: SaveBody) =>
  axios.post<PlanGroup>(PLAN_GROUPS, { ...body });

export const updatePlanGroup = (body: SaveBody & { id: string | number }) =>
  axios.put<PlanGroup>(`${PLAN_GROUPS}/${body.id}`, { ...body });

export const deletePlanGroup = (id: string | number) =>
  axios.delete(`${PLAN_GROUPS}/${id}`);
